export const CONFIG = {
    client_name : "stw_willich",
    client_display_name : "Stadtwerke Willich",
    modal_confirm_button_label : "übernehmen",
    country : 'de',
    base_asset_url : `https://esr.fe-bis.de/de/stw_willich/`,
    plz_validation : (plz : string) => plz.length == 5,
    plz_default: "47877",
    foerderung : true,
    development_mode: false,
}